import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ITSMDashboardService } from './api/iTSMDashboard.service';
import { ITSMMemberPresencesService } from './api/iTSMMemberPresences.service';
import { ITSMMemberStatusesService } from './api/iTSMMemberStatuses.service';
import { ITSMMembersService } from './api/iTSMMembers.service';
import { ITSMRolesService } from './api/iTSMRoles.service';
import { ITSMTicketStatusesService } from './api/iTSMTicketStatuses.service';
import { ITSMTicketsService } from './api/iTSMTickets.service';
import { ITSMTicketsThreadsService } from './api/iTSMTicketsThreads.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ITSMDashboardService,
    ITSMMemberPresencesService,
    ITSMMemberStatusesService,
    ITSMMembersService,
    ITSMRolesService,
    ITSMTicketStatusesService,
    ITSMTicketsService,
    ITSMTicketsThreadsService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
